const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const snack = require('../../../../../components/snack/snack')
const websocket = require('../../../../../js-network/web-socket')
const itemInventorySocket = require('../item/item-inventory-web-socket')
const retailChanges = require('../retail/retail-dt-handler')
const retailDt = require('../retail/retail-dt')
const receivepaymentDt = require('../receivepayment/receivepayment-dt')
const retailDeletedDialog = require('./retailDeleted-dialog')
const retailDeletedDt = require('./retailDeleted-dt')

let restoringRetail = false

export function renderChanges(result, htmlFc) {
      const changesContainer = htmlFc.fullcontHTML.querySelector('#retailDeleted-changes')

      if (!changesContainer) { return }

      changesContainer.innerHTML = ''
      const entityChanges = Array.isArray(result?.entitychanges) ? result.entitychanges : []
      const changes = Array.isArray(entityChanges[0]?.data) ? entityChanges[0].data : []

      if (!changes.length) { return }

      changesContainer.insertAdjacentHTML(
            'beforeend',
            retailChanges.organizeRowEntityChange(changes),
      )
}

export function enforceReadOnly(htmlFc) {
      const fullcont = htmlFc.fullcontHTML

      fullcont.classList.add('mode-view', 'mode-readOnly')
      fullcont.classList.remove('mode-edit', 'mode-add')

      fullcont.querySelectorAll('input, select, textarea, button').forEach((element) => {
            element.disabled = true
            element.setAttribute('readonly', 'readonly')
      })

      fullcont
            .querySelectorAll('.fab-to-edit, .fab-to-add, .fab-to-update, .fab-to-readOnly, .removeLine, .btn, .btn-item-info')
            .forEach((element) => element.classList.add('dn'))
}

export async function restoreRetail(htmlFc) {
      if (restoringRetail) { return }

      const retailId = htmlFc.fullcontHTML.getAttribute('data-dbid')
      if (!retailId) { return }

      const restoreButton = htmlFc.fullcontHTML.querySelector('.fab-restore > .green')
      const formData = new FormData()
      formData.append('retail_id', retailId)

      restoringRetail = true
      restoreButton?.classList.add('disabled')

      try {
            const response = await fetch('./server/php/sql/retailDeletedRestore.php', {
                  method: 'POST',
                  body: formData,
                  credentials: 'same-origin',
            })

            if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

            const result = await response.json()
            const authorized = result.authentication?.val === 'ok'
                  && result.authorization?.val === 'ok'

            if (authorized && result.error?.val === 'inventoryConflict') {
                  retailDeletedDialog.start({
                        act: 'show',
                        id: 'inventoryRestoreConflict',
                        items: result.data,
                  })
                  return
            }

            if (!authorized || result.error?.val !== 'ok') {
                  snack.start({
                        act: 'show',
                        id: 'emailResult',
                        text: result.extrainfo?.message || 'The Retail invoice could not be restored',
                  })
                  return
            }

            const restoredRetail = result.data?.[0]
            const restoredPayment = result.extrainfo?.receivepayment
            const sendDetail = { to: 'allStaff', from: 'staffDesktop', id: '' }

            if (restoredRetail) {
                  restoredRetail.dest = 'retail'
                  addLocalRow('retail-dt', retailDt, restoredRetail)
                  websocket.entityUpdate('entityUpdate', 'addRow', restoredRetail, sendDetail)
                  notifyInventory(restoredRetail)
            }

            if (restoredPayment) {
                  restoredPayment.dest = 'receivepayment'
                  addLocalRow('receivepayment-dt', receivepaymentDt, restoredPayment)
                  websocket.entityUpdate('entityUpdate', 'addRow', restoredPayment, sendDetail)
            }

            websocket.entityUpdate(
                  'entityUpdate',
                  'deleteRow',
                  {
                        id: retailId,
                        dest: 'retailDeleted',
                        entity: 'retailDeleted',
                        dbid: [Number(retailId)],
                  },
                  sendDetail,
            )

            fullcontEntity.hide({ id: 'retailDeleted-fullcont' }, htmlFc)
            retailDeletedDt.start({
                  dest: 'retailDeleted',
                  elem: 'dt',
                  act: 'select',
                  entity: 'retailDeleted',
            })
            snack.start({ act: 'show', id: 'emailResult', text: 'Retail restored successfully' })
      } catch (error) {
            snack.start({
                  act: 'show',
                  id: 'emailResult',
                  text: 'Connection error while restoring Retail',
            })
      } finally {
            restoringRetail = false
            restoreButton?.classList.remove('disabled')
      }
}

function addLocalRow(dtId, entityDt, row) {
      if (document.getElementById(dtId) === null) { return }

      entityDt.start({ act: 'addRow', row: [row] })
}

function notifyInventory(restoredRetail) {
      if (document.getElementById('item-dt') !== null) {
            itemInventorySocket.notifySavedInventory(
                  'sale',
                  restoredRetail,
                  { status: 'ok', restriction: { val: 'ok' } },
            )
            return
      }

      websocket.send({
            act: 'entityUpdate',
            data: {
                  entityCall: {
                        entity: 'item',
                        elem: 'dt',
                        function: 'refreshInventory',
                        params: {
                              sourceEntity: 'sale',
                              sourceId: String(restoredRetail.id),
                        },
                  },
                  sendDetail: { to: 'allStaff', from: 'staffDesktop', id: '' },
            },
      })
}
